var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarkerBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2873_258)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2873_258",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0.564453C5.79086 0.564453 4 2.35531 4 4.56445V24.0024C4 26.2115 5.79086 28.0024 8 28.0024H15.0471L18.5833 31.4321L22.1196 28.0024H28C30.2091 28.0024 32 26.2115 32 24.0024V4.56445C32 2.35531 30.2091 0.564453 28 0.564453H8Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0.564453C5.79086 0.564453 4 2.35531 4 4.56445V24.0024C4 26.2115 5.79086 28.0024 8 28.0024H15.0471L18.5833 31.4321L22.1196 28.0024H28C30.2091 28.0024 32 26.2115 32 24.0024V4.56445C32 2.35531 30.2091 0.564453 28 0.564453H8Z",
    fill: "blue"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0471 28.0024L16.4395 26.5667L15.8576 26.0024H15.0471V28.0024ZM18.5833 31.4321L17.1909 32.8678L18.5833 34.2183L19.9758 32.8678L18.5833 31.4321ZM22.1196 28.0024V26.0024H21.309L20.7272 26.5667L22.1196 28.0024ZM6 4.56445C6 3.45988 6.89543 2.56445 8 2.56445V-1.43555C4.68629 -1.43555 2 1.25074 2 4.56445H6ZM6 24.0024V4.56445H2V24.0024H6ZM8 26.0024C6.89543 26.0024 6 25.1069 6 24.0024H2C2 27.3161 4.68629 30.0024 8 30.0024V26.0024ZM15.0471 26.0024H8V30.0024H15.0471V26.0024ZM13.6546 29.438L17.1909 32.8678L19.9758 29.9964L16.4395 26.5667L13.6546 29.438ZM19.9758 32.8678L23.512 29.438L20.7272 26.5667L17.1909 29.9964L19.9758 32.8678ZM28 26.0024H22.1196V30.0024H28V26.0024ZM30 24.0024C30 25.1069 29.1046 26.0024 28 26.0024V30.0024C31.3137 30.0024 34 27.3161 34 24.0024H30ZM30 4.56445V24.0024H34V4.56445H30ZM28 2.56445C29.1046 2.56445 30 3.45988 30 4.56445H34C34 1.25074 31.3137 -1.43555 28 -1.43555V2.56445ZM8 2.56445H28V-1.43555H8V2.56445Z",
    fill: "white",
    mask: "url(#path-1-inside-1_2873_258)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2873_258",
    x: 0,
    y: 0.564453,
    width: 36,
    height: 38.8672,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2873_258"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2873_258",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerBlue);
export default __webpack_public_path__ + "static/media/map-marker-blue.4aed360ecfc74872746f4b036c0b2e81.svg";
export { ForwardRef as ReactComponent };